import React from 'react'
import omit from 'lodash/omit'
import { FieldRenderProps } from 'react-final-form'
import PropTypes from 'prop-types'

import Textarea from '../Textarea'
import FormGroup from '../FormGroup'
import { parseMessage } from '../Forms/utils'
import { PROP_TYPE_REDUX_FORM_ELEMENT } from '../Forms/constants'

type TextareaFieldProps = FieldRenderProps<string>

const TextareaField = ({
  className,
  help,
  input,
  label,
  maxlength,
  minlength,
  meta,
  optional,
  required,
  ...props
}: TextareaFieldProps) => {
  const error = parseMessage(meta.error || props.error)?.toString()
  const success = parseMessage(props.success)?.toString()
  const touched = meta.touched || props.touched

  return (
    <FormGroup
      className={className}
      disabled={input.disabled}
      error={error}
      help={typeof help === 'string' ? help : undefined}
      label={label}
      maxlength={maxlength}
      name={input.name}
      optional={optional}
      required={required}
      success={success}
      touched={touched}
      value={input.value as string}
    >
      <Textarea
        error={error ?? false}
        touched={touched}
        maxLength={maxlength}
        minLength={minlength}
        {...omit(input, ['error', 'touched'])}
        {...omit(props, ['error', 'touched'])}
        aria-describedby={`${input.name}-help-text ${input.name}-info-text`}
      />
    </FormGroup>
  )
}

TextareaField.propTypes = {
  ...PROP_TYPE_REDUX_FORM_ELEMENT,
} as PropTypes.InferProps<typeof Textarea>

export default TextareaField
